// extracted by mini-css-extract-plugin
export var closeButton = "_g7-2";
export var closeButtonIcon = "_g7-3";
export var lightboxContent = "_g7-1";
export var lightboxOverlay = "_g7-0";